export enum Placement {
    FIT = 'FIT',
    WRAP = 'WRAP',
    AUTO_RESIZE = 'AUTO_RESIZE',
}
